import { Popover, Radio} from "antd";
import { vernacularBlueprintApis } from "./utils/ApiURLs";
import CustomIcon from "./components/icons/CustomIcon";
import { useState } from "react";

const languages = [
    {
        value: 'en',
        label: 'English',
    },
    {
        value: 'hi',
        label: 'Hindi',
    },
    {
        value: 'te',
        label: 'Telugu',
    },
    {
        value: 'ta',
        label: 'Tamil',
    },
    {
        value: 'kn',
        label: 'Kannada',
    },
    {
        value: 'gu',
        label: 'Gujarathi',
    },
    {
        value: 'mr',
        label: 'Marathi',
    },

    {
        value: 'bn',
        label: 'Bengali',
    },
    {
        value: 'ml',
        label: 'Malyalam',
    },
    {
        value: 'or',
        label: 'Odia',
    }
];

export const triggerLangChange = (lang: string) => {
    const event = new CustomEvent("languageChanged", {
        detail: {
            lang: lang,
            blueprintAPI: vernacularBlueprintApis[lang as keyof typeof vernacularBlueprintApis]
        }
    });
    window.dispatchEvent(event);
}


const VernacularDropDown: React.FC = () => {

    const [selectedLanguage, setSelectedLanguage] = useState("en");

    const handleLanguageChange = (e:any) => {
        setSelectedLanguage(e.target.value);
        triggerLangChange(e.target.value);
      };
    
      const popoverContent = (
        <Radio.Group onChange={handleLanguageChange} value={selectedLanguage}>
          {languages.map((language) => (
            <Radio className="d-block my-1" key={language.value} value={language.value}>
              {language.label}
            </Radio>
          ))}
        </Radio.Group>
      );

    return (
        // <Form layout="horizontal" className="text-center mt-2">
        //     <Form.Item>
        //         <Select
        //             suffixIcon={<CustomIcon width="20px" height="20px" name="vernacular"></CustomIcon>}
        //             defaultValue="en"
        //             id="vernacular-drop-down"
        //             style={{ width: 120 }}
        //             onChange={(val) => {
        //                 triggerLangChange(val);
        //             }}
        //             options=
        //         />
        //     </Form.Item>
        // </Form>
        <Popover content={popoverContent} title="Select Language" trigger="click">
            <CustomIcon className="mr-2" width="16px" height="16px" name="vernacular"></CustomIcon> 
        </Popover>
    )
}


export default VernacularDropDown;
